import { type RouteResponseType, RoutesApi } from './RoutesApi';
import { Api, ApiFilterBuilder } from '@automapa/svelte-automapa-template';
import type { QueriesType } from '../../telematics/types';
import type { JobCountType } from '../../Location/types';

export class RoutesApp {
    private items: RouteResponseType[] = [];
    private filter: ApiFilterBuilder = new ApiFilterBuilder(null);
    private query: QueriesType = {};
    private api: Api;

    public constructor(api: Api) {
        this.api = api;
    }

    public setFilter(filter: ApiFilterBuilder): void {
        this.filter = filter;
    }

    public setQuery(query: QueriesType): void {
        this.query = query;
    }

    public async getItems(): Promise<RouteResponseType[]> {
        this.items = await RoutesApi.query(this.api, this.query, this.filter);
        return this.items;
    }

    public async countFilteredItems(): Promise<JobCountType> {
        let f = new ApiFilterBuilder(null);
        return RoutesApi.getCountWithQueries(this.api, this.query, f);
    }

    public async countAllItems(): Promise<JobCountType> {
        let f = new ApiFilterBuilder(null);
        return RoutesApi.getCountWithQueries(this.api, {}, f);
    }

    public async getCurrentTransactionCount(): Promise<JobCountType> {
        return RoutesApi.getCurrentTransactionCount(this.api);
    }
}
